/// 詳細画面の上位タブ件数バッジ用ヘルパー
/// (spec docs/implementation/20260613-tab-counts-and-review-badges.md PR1)。
/// 件数は保存値ではなく取得済みデータから導出し、ここでは表示判定のみ持つ。

/**
 * 件数バッジを表示するか。1 件以上のときだけ表示し、0 件は出さない。
 * `null` は未取得 (読み込み中・取得失敗) を表し、同じく非表示。
 */
export function shouldShowTabCount(count: number | null): boolean {
  return count !== null && count > 0;
}

/**
 * タブボタンの `aria-label`。バッジの見た目は数字だけでも、読み上げでは
 * `営業アクション 2件` のように件数の意味が分かるようにする。
 * 件数なし (0 件・未取得) はタブ名のみ。
 */
export function tabCountAriaLabel(label: string, count: number | null): string {
  return shouldShowTabCount(count) ? `${label} ${count}件` : label;
}

/**
 * 件数バッジと更新ドットを持つタブボタンの `aria-label`。
 * 件数は登録済み情報量、更新ありはユーザー別の閲覧状態からの派生表示。
 */
export function tabStatusAriaLabel(
  label: string,
  count: number | null,
  hasUpdate: boolean,
): string {
  const countLabel = tabCountAriaLabel(label, count);
  return hasUpdate ? `${countLabel} 更新あり` : countLabel;
}
